import React, { useState} from 'react';
import ShapoWidget from './ShapoWidget';
import '../styles/Testimonials.css';

const Testimonials = () => {
  const [isVideoActive, setIsVideoActive] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({ name: '', email: '', review: '' });

  const videoReviews = Array(6).fill(null);

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Review Submitted:', formData);
    setShowModal(false);
    setFormData({ name: '', email: '', review: '' });
  };
  return (
    <>
    <div className="testimonial-container">
      <div className="toggle-buttons">
        <button
          onClick={() => setIsVideoActive(true)}
          style={{ 
            backgroundColor: isVideoActive ? '#3954A4' : '#EB2529',
            color: 'white'
          }}
        >
          YouTube Testimonials
        </button>
        <button
          onClick={() => setIsVideoActive(false)}
          style={{ 
            backgroundColor: !isVideoActive ? '#3954A4' : '#EB2529',
            color: 'white'
          }}
        >
          Google Reviews
        </button>
      </div>

      {isVideoActive ? (
        <div className="video-grid">
          {videoReviews.map((_, index) => (
            <div key={index} className="video-card">
              <iframe
                title={`video-${index}`}
                src=""
                frameBorder="0"
                allowFullScreen
              />
            </div>
          ))}
        </div>
      ) : (
        <div className="written-grid">
            <ShapoWidget />
         </div>
      )}

      <button 
        className="leave-review-btn"
        onClick={() => setShowModal(true)}
      >
        Leave a Review
      </button>

      {showModal && (
        <div className="modal-overlay">
          <div className="modal">
            <button 
              className="close-btn"
              onClick={() => setShowModal(false)}
            >
              ×
            </button>
            <h2>Leave Your Review</h2>
            <form onSubmit={handleSubmit}>
              <input
                type="text"
                placeholder="Name"
                value={formData.name}
                onChange={(e) => setFormData({...formData, name: e.target.value})}
                required
              />
              <input
                type="email"
                placeholder="Email"
                value={formData.email}
                onChange={(e) => setFormData({...formData, email: e.target.value})}
                required
              />
              <textarea
                placeholder="Your review"
                value={formData.review}
                onChange={(e) => setFormData({...formData, review: e.target.value})}
                required
              />
              <button type="submit">Submit Review</button>
            </form>
          </div>
        </div>
      )}
    </div>
    </>
  );
};

export default Testimonials;